<template>
  <div class="bottom-modal__wrap">
    <div class="pb-4">
      <h4>부고 전달 내용 확인 및 수정 후 방법을 선택해주세요</h4>
      <h4>(상단 메세지만 수정 가능합니다.)</h4>
    </div>

    <div class="bottom-modal__content obituary-share"
    style="flex-direction: column;">
      <div
        class="obituary-share-box"
        style="cursor: default;"
      >
        <textarea v-model="titleareaComputed" style="white-space: pre-line; width: 100%; height: auto; resize: none;">
        </textarea>
      </div>
      <div
        class="obituary-share-box"
        style="cursor: default;"
        :class="{ active: !messageRelateType }"
      >
        <span style="max-width: 100%; white-space: pre-line; max-height: 100px; overflow: auto; word-break: break-all;">{{ onlyShow }}</span>
      </div>
    </div>

    <div class="bottom-modal-icon__wrap obituary-share">
      <SnsIcon
        :class="{ active: snsType === 'kakao' }"
        :image="require('@/assets/icons/obituary/kakao.svg')"
        title="카톡"
        @shareSns="snsType = 'kakao'"
      />
      <SnsIcon
        :class="{ active: snsType === 'sms' }"
        :image="require('@/assets/icons/obituary/sms.svg')"
        title="문자"
        @shareSns="snsType = 'sms'"
      />

      <SnsIcon
        :class="{ active: snsType === 'band' }"
        :image="require('@/assets/icons/obituary/band.svg')"
        title="밴드"
        @shareSns="snsType = 'band'"
      />
      <SnsIcon
        :class="{ active: snsType === 'copy' }"
        :image="require('@/assets/icons/obituary/link_copy.svg')"
        title="복사"
        @shareSns="snsType = 'copy'"
      />
    </div>

    <div class="bottom-modal-button__wrap">
      <div class="bottom-modal-button close" @click="close">닫기</div>
      <div class="bottom-modal-button apply" @click="handleShare">공유하기</div>
    </div>

    <a ref="sms" :href="smsHref"></a>
  </div>
</template>

<script
  type="text/javascript"
  src="https://developers.kakao.com/sdk/js/kakao.js"
></script>
<script>
import { mapGetters } from "vuex";
import { makeSmsName } from "../../utils/sms";
import SnsIcon from "./SnsIcon.vue";

export default {
  name: "AccountList",
  components: { SnsIcon },
  data() {
    return {
      id: this.$route.query.id ? this.$route.query.id : null,
      memberId: this.$route.query.memberId ? this.$route.query.memberId : null,
      device: "",

      messageRelateType: true,
      snsType: "kakao",

      messageTxt: "",
      messageTxt2: "",
      messageTxt3: "",
      currentUrl: "",
      titlearea: "",
    };
  },

  computed: {
    ...mapGetters(["getObituary"]),
    encodeId() {
      return (
        this.id &&
        this.id
          .replace(/%20/g, "JR_PLUS")
          .replace(/ /g, "JR_PLUS")
          .replace(/\+/g, "JR_PLUS")
      );
    },

    titleareaComputed: {
      get() {
        return this.titlearea || (this.isRelationMember ? this.messageRelationTxt : this.defaultFirstTxt);
      },
      set(value) {
        this.titlearea = value;
      }
    },

    currentObituaryMember() {
      return (
        this.getObituary?.ObituaryMembers?.length > 0 &&
        this.getObituary?.ObituaryMembers?.filter(
          v => v.id === +this.memberId
        )[0]
      );
    },

    defaultFirstTxt() {
      return this.getObituary.subname 
    ? `故 ${this.getObituary.name}(${this.getObituary.subname})님께서 ${this.getObituary.dieType} 하셨기에 아래와 같이 부고를 전해 드립니다.`
    : `故 ${this.getObituary.name}님께서 ${this.getObituary.dieType} 하셨기에 아래와 같이 부고를 전해 드립니다.`;
    },
    messageRelationTxt() {
      // if (!this.currentObituaryMember || !this.memberId) {
      //   return `故 ${this.getObituary.name}님께서 ${this.getObituary.dieType} 하셨기에 아래와 같이 부고를 전해 드립니다.`;
      // }

      return this.getObituary.subname ? `${makeSmsName(
        this.currentObituaryMember?.memberType,
        this.getObituary?.gender,
        this.currentObituaryMember?.memberName,
        this.getObituary?.name,
        this.currentObituaryMember?.memberSecondType
      )}(${this.getObituary.subname})님께서 ${
        this.getObituary?.dieType
      } 하셨기에 아래와 같이 부고를 전해 드립니다.`
      :
      `${makeSmsName(
        this.currentObituaryMember?.memberType,
        this.getObituary?.gender,
        this.currentObituaryMember?.memberName,
        this.getObituary?.name,
        this.currentObituaryMember?.memberSecondType
      )}님께서 ${
        this.getObituary?.dieType
      } 하셨기에 아래와 같이 부고를 전해 드립니다.`
    },

    endTxt() {
      if (
        (this.getObituary.CorpId && this.getObituary.DirectorId) ||
        (this.getObituary.CorpId && !this.getObituary.DirectorId)
      ) {
        return this.getObituary.Corp.name + "에서 제작된 모바일 부고장입니다.";
      } else if (
        !this.getObituary.CorpId &&
        this.getObituary.DirectorId &&
        this.getObituary?.Director?.name
      ) {
        return (
          this.getObituary?.Director?.name +
          " 장례지도사가 제작한 모바일 부고장입니다."
        );
      } else if (this.getObituary.FuneralId) {
        return (
          this.getObituary.Funeral.name + "에서 제작된 모바일 부고장입니다."
        );
      }

      if (
        this.getObituary.CorpId &&
        this.getObituary.Corp.name === "장례지도사"
      ) {
        return "제작된 모바일 부고장입니다";
      }

      return "제작된 모바일 부고장입니다.";
    },
    memberListString() {
      let memberListString = "";
      const members = [];

      const sortMembers = this.getObituary.ObituaryMembers.sort((a, b) => {
        if (a.typeOrder === b.typeOrder) {
          return a.order - b.order;
        }
        return a.typeOrder - b.typeOrder;
      });

      sortMembers.forEach(v => {
        const index = members.findIndex(arg => arg.type === v.memberType);
        if (v.syncFlag) {
          let addName = v.memberName;
          if (v.memberName === "빈빈빈") {
            addName = "      ";
          }
          if (index !== -1) {
            members[index].value += `, ${addName}`;
          } else {
            if (addName) {
              members.push({
                type: v.memberType,
                value: addName
              });
            }
          }
        }
      });

      members.forEach(v => {
        memberListString += `${v.type}: ${v.value} \n`;
      });

      return memberListString;
    },

    onlyShow() {
      let funeralInfo = `빈소 : ${this.getObituary.Address !== null ? this.getObituary.Address.name : this.getObituary.addrName} / ${this.getObituary.mortuaryName !== null ? this.getObituary.mortuaryName : "빈소미정"}
오시는길: ${this.getObituary.Address !== null ? this.getObituary.Address.address : this.getObituary.addr} / ${this.getObituary.Address !== null ? this.getObituary.Address.phone : this.getObituary.callNumber}`;

      return `${this.memberListString ? `■상주정보■
${this.memberListString}
` : ''}${funeralInfo}

■부고■
${this.currentUrl}

본 메세지는 유가족들의 마음을 담아 ${this.endTxt}`;
    },

    // 故 ${this.getObituary.name}님께서 ${this.getObituary.dieType} 하셨기에 아래와 같이 부고를 전해 드립니다.

    kakaoBody() {
      let funeralInfo = `빈소 : ${this.getObituary.Address !== null ? this.getObituary.Address.name : this.getObituary.addrName} / ${this.getObituary.mortuaryName !== null ? this.getObituary.mortuaryName : "빈소미정"}
오시는길: ${this.getObituary.Address !== null ? this.getObituary.Address.address : this.getObituary.addr} / ${this.getObituary.Address !== null ? this.getObituary.Address.phone : this.getObituary.callNumber}`;
      const smsMessage = `${
  this.titlearea || (this.isRelationMember ? this.messageRelationTxt : this.defaultFirstTxt)
}

■상주정보■
${this.memberListString}

${funeralInfo}

■부고■
${this.messageTxt2}

${this.endTxt}`;

      let realSmsMessage = smsMessage.replace(/(\n|\r\n)/g, "%0a");
      realSmsMessage = smsMessage;

      return realSmsMessage;
    },
    smsBody() {
      let funeralInfo = `빈소 : ${this.getObituary.Address !== null ? this.getObituary.Address.name : this.getObituary.addrName} / ${this.getObituary.mortuaryName !== null ? this.getObituary.mortuaryName : "빈소미정"}
오시는길: ${this.getObituary.Address !== null ? this.getObituary.Address.address : this.getObituary.addr} / ${this.getObituary.Address !== null ? this.getObituary.Address.phone : this.getObituary.callNumber}`;
      const url =
        this.currentUrl ||
        `${process.env.VUE_APP_OBITUARY_BASEURL}/?id=${this.encodeId}`;

      // 故 ${this.getObituary.name}님께서 ${this.getObituary.dieType} 하셨기에 아래와 같이 부고를 전해 드립니다.
      const smsMessage = `${
        this.titlearea || (this.isRelationMember ? this.messageRelationTxt : this.defaultFirstTxt)
      }

${this.memberListString ? `상주정보
${this.memberListString}
` : ''}${funeralInfo}

■부고■
${url}

본 메세지는 유가족들의 마음을 담아 ${this.endTxt}`;

      let realSmsMessage = smsMessage.replace(/(\n|\r\n)/g, "%0a");
      realSmsMessage = smsMessage;

      return encodeURIComponent(realSmsMessage);
    },
    
    smsBodyCopy() {
      let funeralInfo = `빈소 : ${this.getObituary.Address !== null ? this.getObituary.Address.name : this.getObituary.addrName} / ${this.getObituary.mortuaryName !== null ? this.getObituary.mortuaryName : "빈소미정"}
오시는길: ${this.getObituary.Address !== null ? this.getObituary.Address.address : this.getObituary.addr} / ${this.getObituary.Address !== null ? this.getObituary.Address.phone : this.getObituary.callNumber}`;
      const url =
        this.currentUrl ||
        `${process.env.VUE_APP_OBITUARY_BASEURL}/?id=${this.encodeId}`;

      // 故 ${this.getObituary.name}님께서 ${this.getObituary.dieType} 하셨기에 아래와 같이 부고를 전해 드립니다.
      const smsMessage = `${
        this.titlearea || (this.isRelationMember ? this.messageRelationTxt : this.defaultFirstTxt)
      }

${this.memberListString ? `■상주정보■
${this.memberListString}
` : ''}${funeralInfo}

■부고■
${url}

본 메세지는 유가족들의 마음을 담아 ${this.endTxt}`;

      return smsMessage;
    },
    checkMobile() {
      var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

      if (varUA.indexOf("android") > -1) {
        //안드로이드
        return "android";
      } else if (
        varUA.indexOf("iphone") > -1 ||
        varUA.indexOf("ipad") > -1 ||
        varUA.indexOf("ipod") > -1 ||
        varUA.indexOf("mac") > -1
      ) {
        //IOS
        return "ios";
      } else {
        //아이폰, 안드로이드 외
        return "other";
      }
    },

    smsHref() {
      return (
        "sms:" +
        (this.checkMobile === "ios" ? "&" : "?") +
        "body=" +
        this.smsBody
      );
    },

    isRelationMember() {
      // 동성 부고장이면
      if (this.getObituary.eventNo) {
        return this.currentObituaryMember?.memberSecondType;
      }

      // 기존 부고장이면
      return this.currentObituaryMember;
    }
  },

  mounted() {
    const device = navigator.userAgent.toLowerCase(); // userAgent 값 얻기

    if (device.includes("android")) {
      // 안드로이드
      this.device = "android";
    } else if (
      device.includes("iphone") ||
      device.includes("ipad") ||
      device.includes("ipod")
    ) {
      this.device = "ipone";
      console.log("");
    } else {
      // 아이폰, 안드로이드 외 모바일
      this.device = "desktop";
    }

    const encodeId = this.encodeId;
    this.currentUrl = window.location.href;

    if (this.id) {
      this.currentUrl = this.currentUrl
        .replace(/%20/g, "JR_PLUS")
        .replace(/ /g, "JR_PLUS")
        .replace(/\+/g, "JR_PLUS");
    }

    this.messageTxt2 =
      this.currentUrl ||
      `${process.env.VUE_APP_OBITUARY_BASEURL}/?id=${encodeId}`;
  },

  methods: {
    close() {
      this.$emit("close");
    },

    sendLinkKakao() {
      this.$kakao.Link.sendDefault({
        objectType: "text",
        text: this.kakaoBody,
        link: {
          mobileWebUrl: this.messageTxt2,
          webUrl: this.messageTxt2
        }
      });
    },
    shareNaverBand() {
      const content = this.smsBody;
      const link = `http://band.us/plugin/share?body=${content}&route=${encodeURIComponent(
        this.currentUrl
      )}`;

      window.open(link, "share", "width=500, height=500");
    },

    // copyLink() {
    //   if (!document.queryCommandSupported("copy")) {
    //     return alert("복사하기가 지원되지 않는 브라우저입니다.");
    //   }

    //   const textarea = document.createElement("textarea");
    //   textarea.value =
    //     this.currentUrl ||
    //     `${process.env.VUE_APP_OBITUARY_BASEURL}/?id=${this.encodeId}`;
    //   textarea.style.top = 0;
    //   textarea.style.left = 0;
    //   textarea.style.position = "fixed";

    //   document.body.appendChild(textarea);

    //   textarea.focus();
    //   textarea.select();
    //   document.execCommand("copy");
    //   document.body.removeChild(textarea);
    //   alert("클립보드에 복사되었습니다.");
    // },
    async copyLink() {
      const textToCopy = this.smsBodyCopy;
      try {
        console.log(textToCopy);
        await navigator.clipboard.writeText(textToCopy);
        alert("클립보드에 복사되었습니다.");
      } catch (err) {
        if (!document.queryCommandSupported("copy")) {
          return alert("복사하기가 지원되지 않는 브라우저입니다.");
        }

        const textarea = document.createElement("textarea");
        textarea.value = textToCopy;
        textarea.style.top = 0;
        textarea.style.left = 0;
        textarea.style.position = "fixed";

        document.body.appendChild(textarea);

        textarea.focus();
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        alert("클립보드에 복사되었습니다.");
      }
    },
    handleShare() {
      switch (this.snsType) {
        case "kakao":
          this.sendLinkKakao();
          break;

        case "sms":
          this.$refs.sms.click();
          break;

        case "band":
          this.shareNaverBand();
          break;

        case "copy":
          this.copyLink();
          break;
        default:
          break;
      }

      this.close();
    }
  }
};
</script>

<style></style>
